const locale = {
	IS_HIDDEN: 'Nascosta',
	IS_PERSONAL: 'Personale',

	DETAILS_DOCUMENTS_FOLDERS_FIELD_TITLE: 'Nome',
	DETAILS_DOCUMENTS_FOLDERS_FIELD_ORDER: 'Ordine',
	DETAILS_DOCUMENTS_FOLDERS_FIELD_ACTIVE: 'Attiva',
	DETAILS_DOCUMENTS_FOLDERS_FIELD_PERSONAL: 'Personale',

	DETAILS_DOCUMENTS_FOLDERS_CONTENT_SECTION: 'Contenuto cartella',
	DETAILS_DOCUMENTS_FOLDERS_CONTENT_SECTION_SUBHEADER: 'Visualizza i file contenuti nella cartella',

	TAB_USERS_FOLDERS: 'Cartelle Utenti',
	DOCUMENTS_VIEW_CONTENT: 'Visualizza Contenuto',
	DETAILS_HEADER_BUTTON_FOLDERS_DOCUMENTS_SETTINGS: 'Configurazione documenti'
};

export default locale;
